import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Routes, Route, Navigate } from 'react-router-dom';

import { Layout, Header } from 'common/components';

import { selectIsLogged, logoutActions, checkUserActions, selectUserProfile } from '../auth/ducks';

import FormsFeature from './features/forms';
import MenuFeature from './features/menu';
import AdminFormsFeature from './features/adminForms';

function HomeFeature() {
  const dispatch = useDispatch();
  const logged = useSelector(selectIsLogged);
  const profile = useSelector(selectUserProfile);

  useEffect(() => {
    dispatch(checkUserActions.request());
  }, [dispatch]);

  return (
    <Layout>
      <Header logged={logged} onLogout={() => dispatch(logoutActions.request())} />
      <Layout.Content>
        <Layout.Container>
          <Routes>
            <Route path="menu" element={<MenuFeature />} />
            <Route path="forms" element={profile?.roles?.privileged ? <AdminFormsFeature /> : <FormsFeature />} />
            <Route path="*" element={<Navigate to="../menu" replace />} />
          </Routes>
        </Layout.Container>
      </Layout.Content>
    </Layout>
  );
}

export default HomeFeature;
